import type {ReactNode} from 'react';

interface Props {
  title?: string | null;
  id?: string;
  children: ReactNode;
}

export const BlockLayout = ({title, id, children}: Props) => {
  return (
    <div id={id} className="flex flex-col gap-3 py-6">
      {title && (
        <h2 className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">
          {title}
        </h2>
      )}
      {children}
    </div>
  );
};
